import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import ProcessTypes from "../../redux/processes/types"
import BundleForm from "./Form"
import ProgressOverlay from "../ProgressOverlay"

class AddBundle extends Component {

  render() {
    const { bundleCreating, addBundle, failed, running, success, error } = this.props

    return (
      <div>

        <ProgressOverlay visible={ bundleCreating }>
          Creating a new bundle...
        </ProgressOverlay>

        <BundleForm
          bundle={{}}
          onSaveClicked={ addBundle }
          failed={ failed }
          running={ running }
          success={ success }
          error={ error }
        />
      </div>
    )
  }
}

AddBundle.propTypes = {
  addBundle: PropTypes.func.isRequired
}

const mapStateToProps = state => {

  const mapping = {

    running: DckSelectors.selectProcessRunning(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    failed: DckSelectors.selectProcessFailed(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    success: DckSelectors.selectProcessSuccess(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    result: DckSelectors.selectProcess(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),
  }

  mapping['error'] = (mapping.failed && mapping.result && mapping.result.result)
    ? mapping.result.result.message : null

  return mapping
}

const mapDispatchToProps = dispatch => ({
  addBundle: data => dispatch(DckActionCreators.itemAdd(ItemTypes.Bundle, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddBundle)



// WEBPACK FOOTER //
// ./src/components/Bundles/Add.js